// @flow
import styled from 'styled-components';
import { paleBlue } from '../../../colors';
/*::
import type { Node } from 'react';

export type TabThemeType = {|
  Main: * => Node,
|};
*/

var thm
/*: TabThemeType */
= {
  // default theme
  Main: styled.em.withConfig({
    displayName: "theme__Main",
    componentId: "sc-17ps633-0"
  })(["padding:0.8rem 3rem;cursor:pointer;margin-left:2rem;font-style:normal;white-space:nowrap;&:first-of-type{margin-left:0;}&.active{background-color:", ";border-radius:2rem;}"], paleBlue())
};
export default thm;